export const CLIENT_KEY_FB = '716928320650659';
export const REDIRECT_URI = 'https://app.viettelmedia.vn/inbox/hub/channel';
export const DOMAIN_APP_VIETTELMEDIA = 'https://app.viettelmedia.vn';
export const DOMAIN_APP_VIETTELMEDIA_LOGIN = 'https://app.viettelmedia.vn/login';
export const CLIENT_KEY = 'social';
export const DOMAIN_LOGIN_ACCOUNT_VIETTELMEDIA = 'https://account.viettelmedia.vn/login';
export const DOMAIN_POS_VIETTELMEDIA = 'https://pos.viettelmedia.vn';
export const LOGIN_URL_SSO = `${DOMAIN_LOGIN_ACCOUNT_VIETTELMEDIA}?clientKey=${CLIENT_KEY}&returnUrl=${encodeURIComponent(DOMAIN_APP_VIETTELMEDIA_LOGIN)}`;

export const ERROR_MESSAGE_AXIOS = {
   '-102': 'Phiên đăng nhập hết hạn, vui lòng đăng nhập lại',
   '-103': 'Phiên đăng nhập hết hạn, vui lòng đăng nhập lại',
}

export const ERROR_CODE_AXIOS = {
   TOKEN_EXPIRED_1: -102,
   TOKEN_EXPIRED_2: -103,
   NOT_AUTHORIZED: 401,
   SUCCESS: 200,
}

export const SUB_SOCKET_FB_PAGE = '/user/page/';
export const UPLOAD_MAX_FILE_SIZE = 1024 * 1024 * 5; //Max 5MB

export const POS_ORDER_DETAIL = `${DOMAIN_POS_VIETTELMEDIA}/#/app/sales/detail`;
export const POST_SETTING_SHIPMENTS = `${DOMAIN_POS_VIETTELMEDIA}/#/app/settings/shipments`;
export const POST_SETTING_WAREHOUSE = `${DOMAIN_POS_VIETTELMEDIA}/#/app/warehouse`;
export const POST_SETTING_PAYMENTS = `${DOMAIN_POS_VIETTELMEDIA}/#/app/setting/payments`;
export const PAYMENT_METHOD = {
   COD: 40,
   BANK: 43,
   VTPAY: 10
}

export const PAYMENT_TYPE = {
   PAYMENT_URL: 1,
   PAYMENT_QRCODE: 2
}

export const SECRET_KEY_PAYMENT = "8zUDKHl3047G+sIPfq9NFPY3Yt8=";